/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-08-23 11:24:19
 * @modify date 2021-08-23 11:24:19
 * @desc [枚举]
 */

/**
 * @export 通知类型
 * @enum
 */
export enum EnumMicroNoticeType {
  RouteChange = 'RouteChange',
}
export enum EnumMicroApp {
  /** 微前端路径 */
  MicroPage = '/micro/',
  /** Iframe路径 */
  IframePage = '/webview/',
  /** 应用名称 key */
  APP = 'app',
  /** Protal 路径标记 */
  Protal = '@Protal',
}
/**
 * 路由类型
 * @export
 * @enum {number}
 */
export enum EnumMicroHistory {
  /** 平台内置 */
  Browser = 'browser',
  /** 微应用 */
  Hash = 'hash',
}
